<template>
    <div class="animated fadeIn"
    v-on:keyup.enter="InserirOuEditar">
      <b-row>
        <b-col sm="12" >
          <div class="fright margin-5-bottom">
              <b-button variant="secondary" class="btn-square margin-5-right" @click="Voltar" >Cancelar</b-button>
              <botao-duplo-clique variant="success" @click="InserirOuEditar" ref="botaoSalvar"/>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col >
          <b-card>
            <div slot="header">
              <strong>Balança </strong><small>{{balancaId != null ? "Edição" : "Inserção"}}</small>
            </div>
            <b-row>
              <b-col sm="4">
                <validator prop-name="Modelo" :erros="erros" campo-descritivo="* Modelo">
                  <b-form-input v-model="Modelo"
                    type="text"
                    id="Modelo"
                    slot="component"
                    placeholder="Digite o modelo "></b-form-input>
                </validator>
              </b-col>
              <div class="col-sm-12 col-md-2 col-lg-2 col-xl-2 mr-5">
                <validator prop-name="PortaCom" :erros="erros" campo-descritivo="* Porta COM">
                <b-form-input v-model="PortaCom"
                  type="text"
                  id="PortaCom"
                  slot="component"/>
              </validator>
            </div>
            <div class="d-flex">
                <b-form-group  >
                  <label for="vat">xOff</label>
                  <div>
                    <c-switch  size="lg" class="mx-1" color="info" v-model="xOff"/>
                  </div>
                </b-form-group>
  
  
              <b-form-group >
                <label for="vat">xOn</label>
                <div>
                  <c-switch  size="lg" class="mx-1" color="info" v-model="xOn"/>
                  </div>
              </b-form-group>
  
              <b-form-group >
                          <label for="vat">RTS</label>
                          <div>
                              <c-switch  size="lg" class="mx-1" color="info" v-model="Rts"/>
                          </div>
                    </b-form-group>
                    <b-form-group >
                          <label for="vat">xAny</label>
                          <div>
                              <c-switch  size="lg" class="mx-1" color="info" v-model="xAny"/>
                          </div>
                    </b-form-group>
              </div>
            </b-row>

            <b-row>
            </b-row>

            <b-row>
                <b-col sm="12">
                    <div class="d-flex">

                        <validator prop-name="Bitrate" :erros="erros" campo-descritivo="Bits por Segundo ">
                            <b-form-select 
                            v-model="Bitrate" 
                            id="Bitrate"
                            :options="optionsBitRate" 
                            class="mb-3"
                            slot="component" />
                        </validator>
                        <div class="col-sm-6 col-md-2 col-lg-2 col-xl-2">

                          <validator prop-name="DataBit" :erros="erros" campo-descritivo="Bits de dados ">
                            <b-form-select 
                            v-model="DataBit" 
                            id="DataBit"
                            :options="optionsDataBit" 
                            class="mb-3"
                            slot="component" />
                          </validator>
                        </div>
                        <validator prop-name="Paridade" :erros="erros" campo-descritivo="Paridade">
                          <b-form-select 
                          v-model="Paridade" 
                          id="Paridade"
                          :options="optionsParidade" 
                          class="mb-3"
                          slot="component" />
                        </validator>
                    </div>
                </b-col>
            </b-row> 

              <b-row>
                <b-col sm="12">
                  <div class="d-flex">
                    
                    
                    <validator prop-name="Separador" :erros="erros" campo-descritivo="Separador decimal">
                      <b-form-select 
                      v-model="Separador" 
                      id="Separador"
                      :options="optionsSeparador" 
                      class="mb-3"
                      slot="component" />
                    </validator>

                    <div class="col-sm-6 col-md-2 col-lg-2 col-xl-2">
                    <label>Casas decimais</label>
                    <div class="form-group">
                        <input
                        id="CasasDecimais"
                        v-model="CasasDecimais"
                        class="form-control"
                        type="number"
                        />
                    </div>
                    </div>
                    <b-col sm="6">
                <validator prop-name="ComputadorId" :erros="erros" campo-descritivo="ComputadorId">
                  <b-form-input v-model="ComputadorId"
                    type="text"
                    id="ComputadorId"
                    slot="component"
                    disabled></b-form-input>
                </validator>
              </b-col>
                  </div>
                  </b-col>
                </b-row> 

            <b-row>
              
            </b-row>
  
            <b-row>
                <div class="col-sm-12 col-md-5 col-lg-5 col-xl-6">
                    <div class="form-group">
                    <label for="PesoTeste">Testar Comunicação</label>
                    <div class="d-flex">
                        <b-button variant="warning" class="btn-square margin-5-right" @click="TestarComunicacao">Capturar Peso</b-button>
                        <input id="PesoTeste" v-model="PesoTeste" class="form-control" disabled type="text" />
                    </div>
                    </div>
                </div>
            </b-row>
            <b-alert v-if="mensagem" dismissible show :variant="mensagem.tipo"> {{mensagem.mensagem}} </b-alert>
              
          </b-card>
        </b-col>
      </b-row>
    </div>
  </template>
  
  <script>
  import { Switch as cSwitch } from '@coreui/vue'
  import { machineId } from 'node-machine-id';
  import { isElectron } from '../../shared/isElectron';

  export default {
    name: 'nova-configuracao',
      components:{
        cSwitch,
    },
    computed:{
      now(){
        var date = new Date()
        return date.toISOString().split('T')[0]
      },
      BalancaViewModel(){
        var vm =this
  
        return {
          Id: this.balancaId || this.$uuid.v4(),
          ContaId: this.$store.getters.getAutenticacao.contaId,
          UsuarioCadastroId: this.usuarioDeCadastroId,
          DataCadastro: this.dataDeCadastro,
          Modelo: this.Modelo,
          PortaCom: this.PortaCom,
          Bitrate: this.Bitrate,
          DataBit: this.DataBit,
          Paridade: this.Paridade,
          Rts: this.Rts,
          xAny: this.xAny,
          xOff: this.xOff,
          xOn: this.xOn,
          Separador: this.Separador,
          CasasDecimais: this.CasasDecimais,
          ComputadorId: this.ComputadorId,
          ClienteId: this.ClienteId,
        }
      }
    },
    async created() {
      this.ComputadorId = await this.getMacAddress();

      if(this.ComputadorId == undefined){
        this.$store.commit("set_mensagem",{tipo: "danger", mensagem: "Não é possivel cadastrar/editar uma balança pela web, efetuar o processo pelo aplicativo!"})
        this.$router.push('/configuracoes/1')
        return;
      }

      this.GetBalanca()
      if(!this.balancaId) this.dataDeCadastro= this.now
    },
    data() {
      return {
        options: [],
          balancaId: this.$route.params.id || null,
          usuarioDeCadastro: this.$store.getters.getAutenticacao.apelido,
          usuarioDeCadastroId: this.$store.getters.getAutenticacao.usuarioId,
          ClienteId: this.$store.getters.getAutenticacao.clienteId,
          dataDeCadastro: this.now,
          Modelo: "",
          PortaCom:"",
          Bitrate:9600,
          DataBit:8,
          Paridade:'none',
          Rts:false,
          xAny:false,
          xOff:false,
          xOn:false,
          Separador: ',',
          CasasDecimais: 3,
          PesoTeste:"",
          ComputadorId:"",
          erros: [],     
          mensagem:null,    
          optionsBitRate: [
            { value: 110, text: '110' },
            { value: 150, text: '150' },
            { value: 300, text: '300' },
            { value: 600, text: '600' },
            { value: 1200, text: '1200' },
            { value: 1800, text: '1800' },
            { value: 2000, text: '2000' },
            { value: 2400, text: '2400' },
            { value: 3600, text: '3600' },
            { value: 4800, text: '4800' },
            { value: 7800, text: '7800' },
            { value: 9600, text: '9600' },
            { value: 10400, text: '10400' },
            { value: 14400, text: '14400' },
            { value: 15625, text: '15625' },
            { value: 19200, text: '19200' },
            { value: 28800, text: '28800' },
            { value: 38400, text: '38400' },
            { value: 56000, text: '56000' },
            { value: 57600, text: '57600' },
            { value: 115200, text: '115200' },
            { value: 128000, text: '128000' },
            { value: 256000, text: '256000' }
          ],
          optionsDataBit: 
          [
            { value: 4, text: '4' },
            { value: 5, text: '5' },
            { value: 6, text: '7' },
            { value: 8, text: '8' },
          ],
          optionsParidade: 
          [
            { value: 'default', text: 'Default' },
            { value: 'even', text: 'Even' },
            { value: 'mark', text: 'Mark' },
            { value: 'none', text: 'None' },
            { value: 'odd', text: 'Odd' },
            { value: 'space', text: 'Space' },
          ],
          optionsSeparador: 
          [
            { value: ',', text: 'Virgula' },
            { value: '.', text: 'Ponto' },
          ],
      }
    },
    methods: {
      Voltar(){
        this.$router.push('/configuracoes/1')
      },
      GetBalanca(){
        if(this.balancaId == null ) return
        var vm = this
        this.$http({url: '/configuracao/editar/' +  this.$route.params.id + "/" + this.$store.getters.getAutenticacao.contaId , method: 'GET' })
          .then(response => {
            vm.usuarioDeCadastroId = response.data.usuarioCadastroId
            vm.usuarioDeCadastro = response.data.usuarioCadastro
            vm.dataDeCadastro = response.data.dataCadastro
            vm.Modelo =  response.data.modelo
            vm.PortaCom = response.data.portaCom
            vm.Bitrate = response.data.bitrate
            vm.DataBit = response.data.dataBit
            vm.Paridade = response.data.paridade
            vm.Rts = response.data.rts
            vm.xAny = response.data.xAny
            vm.xOff = response.data.xOff
            vm.xOn = response.data.xOn
            vm.Separador = response.data.separador
            vm.CasasDecimais = response.data.casasDecimais
        })
        .catch(err => {
            this.$router.push('/500')
        })
      },
      InserirOuEditar(){
        if(this.balancaId != null ){
          this.Editar()
          return
        }
  
        this.Inserir()
      },
      Editar(){
        var vm = this
        this.$http({url: '/configuracao/editar', data: this.BalancaViewModel, method: 'PUT'  })
          .then(response => {
            if(!response.data.sucesso){
              vm.erros = response.data.erros
              vm.$refs.botaoSalvar.unloading()
              return
            }
            this.$store.commit("set_mensagem",{tipo: "success", mensagem: "A balança foi editada com sucesso!"})
            this.$router.push('/configuracoes/1')
        })
        .catch(err => {
            this.$store.commit("set_mensagem",{tipo: "danger", mensagem: err.response.data.errors})
            this.$router.push('/configuracoes/1')
        })
      },
      Inserir(){
        var vm = this
        this.$http({url: '/configuracao/novo', data: this.BalancaViewModel, method: 'POST'  })
          .then(response => {
            if(!response.data.sucesso){
              vm.erros = response.data.erros
              vm.$refs.botaoSalvar.unloading()
              return
            }
            this.$store.commit("set_mensagem",{tipo: "success", mensagem: "A balança foi salva com sucesso!"})
            this.$router.push('/configuracoes/1')
        })
        .catch(err => {
            this.$store.commit("set_mensagem",{tipo: "danger", mensagem: err.response.data.errors})
            this.$router.push('/configuracoes/1')
        })
      },
      async TestarComunicacao(){
        if(this.PortaCom ==""){
          this.mensagem = {tipo: "danger", mensagem: "É necessario informar uma porta COM! "}
          return;
        }
        if (isElectron) {
	        //const { SerialPort } = await import('serialport');
          let vm= this;
          vm.mensagem = null;
          vm.PesoTeste = 0;
          const port = new SerialPort(
            { path: this.PortaCom,
                      baudRate: this.Bitrate,
                      dataBits: this.DataBit,
                      parity: this.Paridade,
                      rtscts: this.Rts,
                      stopBits: 1,
                      xany: this.xAny,
                      xoff: this.xOff,
                      xon: this.xOn,
                    });
                    
          // Escute os eventos de 'data' para ler os dados

          port.on('open', (err) => {
            if (err) {
              return console.error('Error opening port: ', err.message);
            }
            
            console.log('Port opened');

            //para balanca toledo necessario enviar o comando para "escutar" o peso
            port.write(Buffer.from([0x05]), (err) => {
              if (err) {
                return console.log('Error on write: ', err.message);
              }
              console.log('Command sent');
            });

            port.on('readable', function () {
            const data = port.read();
            let numero = data.toString().match(/\d+(\.\d+)?/);
            const numerico = parseFloat(numero[0])
            let resultado = (numerico/Math.pow(10, vm.CasasDecimais)).toFixed(vm.CasasDecimais);
            vm.PesoTeste = resultado.replace(".", vm.Separador);
            console.log("PesoResultado",vm.PesoTeste)          
            vm.mensagem = {tipo: "success", mensagem: "Comunicação com a balança feita com sucesso!"}
          })

          setTimeout(() => {
            port.close((err) => {
              if (err) {
                console.error('Erro ao fechar a conexão:', err);
              } else {
                console.log('Conexão fechada com a balança.');
                if(vm.PesoTeste === 0)
                vm.mensagem = {tipo: "danger", mensagem: "Nenhum peso registrado, verifique se a balança está estavel e tente novamente!"}
              }
            });
          }, 200);

          });

          // Lida com erros na comunicação serial
          port.on('error', (error) => {
            console.error('Erro na comunicação serial:', error);
            this.mensagem = {tipo: "danger", mensagem: "Erro na comunicação serial: " + error}
            //alert('Erro na comunicação serial: ' + error)
          });
        }
      },
      async getMacAddress() {
        try {
          const macAddress = await machineId();
          return macAddress;
        } catch (error) {
          this.error = error;
        }
    }
    },
  }
  </script>